import { Dropdown } from "@legacy/Dropdown";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Chip } from "@mui/material";
import { useState } from "react";

export const ChipsList = ({ items, limit, onDelete }) => {
  /**
   * @States
   */
  const [dropdownOpen, toggleDropdown] = useState(false);
  let displayTags = items || [];
  let moreTags;
  if (limit) {
    displayTags = items.slice(0, limit);
    moreTags = items.slice(limit, items.length);
  }

  return (
    <>
      {displayTags?.map((item, index) => {
        return (
          <Chip
            key={index}
            tabIndex={-1}
            label={item}
            color="secondary"
            size="small"
            onDelete={onDelete(item)}
            sx={{ my: 0.5, mx: 0.25 }}
          />
        );
      })}
      {moreTags?.length > 0 && (
        <Dropdown
          id="more-chip-dropdown"
          type="button"
          togglerProps={{
            size: "xs-flat",
            variant: "text",
            startIcon: <AddRoundedIcon />,
          }}
          PaperProps={{
            variant: "outlined",
            sx: { display: "flex", flexDirection: "column" },
          }}
          elevation={0}
          buttonText={`${moreTags.length}`}
          open={dropdownOpen}
          onClick={() => toggleDropdown(!dropdownOpen)}
        >
          {moreTags.map((item) => {
            return (
              <Chip
                key={item}
                tabIndex={-1}
                label={item}
                color="secondary"
                size="small"
                onDelete={onDelete(item)}
                sx={{
                  my: 0.5,
                  mx: 0.25,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              />
            );
          })}
        </Dropdown>
      )}
    </>
  );
};
